import { DisplayErrors } from "../../../../../Utils/ErrorHandler";
import { Translate } from "../../../../../Utils/TranslationUtils";
import useApi from "../../../../../Utils/BackendClient";
import { useFormik } from "formik";
import { useRef, useState } from "react";
import { useIsMobile } from "../../../../../Utils/ResizeUtils";
import { useLocation, useNavigate } from "react-router-dom";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";

import CommonToolbar from "../../../../UIElements/CommonToolbar";

import commonStyle from "../../../CommonStyles.module.css";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";

const B2bSkladPlugin = () => {

    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef();

    const { fetchPluginDetails, updatePluginSettings } = useApi();

    const [pluginDetails, setPluginDetails] = useState({
        settings: []
    });
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);

    const menuItems = [
        {
            label: "Управління",
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            }
        },
        {
            label: "Налаштування",
            icon: 'pi pi-cog',
            command: () => {
                getPluginDetails();
                setTabShowed(1);
            }
        }
    ]

    const confirmLeave = (event) => {

        if (formik.values !== pluginDetails) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/marketplace") }
            });

        }
        else {
            navigate("/marketplace");
        }
    }

    const getPluginDetails = async () => {
        if (location.state?.pluginName) {
            const response = await fetchPluginDetails(location.state.pluginName);

            console.log(response.status);
            if (response.status === 200) {
                setPluginDetails(response.data);
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
        else{
            toast.current.show( )
        }
    };

    const formik = useFormik({
        initialValues: pluginDetails,
        enableReinitialize: true,
        validate: values => {
            const errors = {};
            return errors;
        },
        onSubmit: async (values) => {
            setSubmitLoading(true);

            const payload = {
                plugin_name: values.plugin_name,
                is_enabled: values.is_enabled,
                settings: values.settings
            }

            const response = await updatePluginSettings(payload);

            if(response.status === 200){
                navigate("/marketplace");
            }
            else{
                DisplayErrors(response.error, toast);
            }

            setSubmitLoading(false);
        }
    });

    const toolbarLeftData = () => {
        return !isMobile ? <h3>{"Деталі плагіну"}</h3> : null;
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Toast ref={toast} />
            <CommonToolbar isMobile={isMobile} isFinalized={false} loading={submitLoading} onRetunButtonClick={() => confirmLeave()} leftContent={toolbarLeftData()} />
            <ConfirmDialog group="headless" />
            <TabMenu model={menuItems} />
            {tabShowed === 1 && <div className="grid">
                <div className={`${commonStyle.leftMenu} col-3`}>
                    {Object.entries(formik.values?.settings).map(([key, value]) => (
                        <div className={`${commonStyle.formInput}`}>
                            <div className="p-inputgroup flex-column">
                                <FloatLabel>
                                    <InputText
                                        id={key}
                                        value={value}
                                        onChange={(e) => formik.setFieldValue(`settings.${key}`, e.target.value)}
                                        className="w-full"
                                        autoFocus
                                    />
                                    <label>{Translate(key)}</label>
                                </FloatLabel>
                            </div>
                        </div>
                    ))}
                </div>
            </div>}
        </form>
    );

}

export default B2bSkladPlugin;